import {Component} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';
@Component({selector:'app-meu-plano',templateUrl:'./meu-plano.component.html',styleUrl:'./meu-plano.component.css',standalone:false})
export class MeuPlanoComponent {
  carregando=true; atual:any=null; upgrades:any[]=[];
  constructor(http:HttpClient){http.get<any>(`${environment.apiUrl}/Portal/Plano`).subscribe({next:r=>{this.atual=r.atual;this.upgrades=r.upgrades||[];this.carregando=false},error:()=>this.carregando=false});}
}
